class LqdParticlesHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.setID();
    this.checkAndRemoveExisting();

    this.initMoveElement();
    this.initParticles();

  }

  getDefaultSettings() {
    return {
      selectors: {
        moveElementElement: '[data-move-element]',
        particlesElement: '[data-particles]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $moveElementElement: this.$element.find(selectors.moveElementElement),
      $particlesElement: this.$element.find(selectors.particlesElement),
    }
  }

  setID() {
    this.$element.find('.ld-particles-container').attr('data-id', `lqd-particles-${this.getID()}`);
  }

  checkAndRemoveExisting() {
    const $existingEl = this.$element.closest('.elementor-section').children('.lqd-particles-bg-wrap');
    if ( $existingEl.length && $existingEl.find(`[data-id="lqd-particles-${this.getID()}"]`).length ) {
      $existingEl.remove();
    }
  }

  initMoveElement() {

    this.elements.$moveElementElement.liquidMoveElement();

  }

  initParticles() {

    this.elements.$particlesElement.liquidParticles();

  }
  
  onDestroy() {

    super.onDestroy();

    this.checkAndRemoveExisting();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdParticlesHandler, { $element } );
};